import styled, { css } from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

interface WrapperProps {
    hasNoSpacings?: boolean
    hasSmallerSpacingsX?: boolean
    hasSmallerSpacingsY?: boolean
    isOverflowVisible?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
    width: 100%;
    padding: ${({ hasNoSpacings }) => (hasNoSpacings ? '0' : '24px 16px')};
    box-shadow: 0 12px 35px rgb(138 150 198 / 5%);
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 6px;
    ${({ isOverflowVisible }) =>
        !isOverflowVisible &&
        css`
            overflow: hidden;
        `};

    @media ${respondAbove.xl} {
        ${({ hasSmallerSpacingsX, hasNoSpacings }) =>
            !hasNoSpacings &&
            css`
                padding-left: ${`${hasSmallerSpacingsX ? 40 : 80}px`};
                padding-right: ${`${hasSmallerSpacingsX ? 40 : 80}px`};
            `}

        ${({ hasSmallerSpacingsY, hasNoSpacings }) =>
            !hasNoSpacings &&
            css`
                padding-top: ${`${hasSmallerSpacingsY ? 40 : 56}px`};
                padding-bottom: ${`${hasSmallerSpacingsY ? 40 : 56}px`};
            `}

        border-radius: 10px;
        overflow: hidden;
    }
`
